import axios from "../_helpers/axiosinstance";
import { getApiEndpoint, Endpoint } from "../nhd-config";

const getEndpoint = () => getApiEndpoint(Endpoint.HazardSearch);

const customSearch = async (params, pageSize, pageNumber, csv, save, sortOptions) => {
  let url = `${getEndpoint()}/nhd/api/hazard/custom-search`;
  let config = {};
  if (csv) {
    url = `${getEndpoint()}/nhd/api/hazard/custom-search/export`;
  }
  if (save) {
    url = `${getEndpoint()}/nhd/api/hazard/custom-search/save`;
  }

  let sortBy = undefined;
  let sortOrder = undefined;

  if (sortOptions?.accessor && sortOptions?.direction) {
    sortBy = sortOptions.accessor;
    sortOrder = sortOptions.direction;
  }

  const response = await axios.post(
    url,
    {
      page: pageNumber === 0 ? 0 : pageNumber || params?.pageNumber || 0,
      pageSize: pageSize === 0 ? 0 : pageSize || params?.pageSize || 10,
      route: params?.route || undefined,
      sortBy: sortBy || undefined,
      sortOrder: sortOrder || undefined,
      elr: params?.elrCS || undefined,
      startMileage: params?.startMileage || undefined,
      endMileage: params?.endMileage || undefined,
      subzone: params?.mdu?.subzonecode || undefined,
      hazard_code: params?.hazardCode || undefined,
      hazard_id: params?.hazard_id || undefined,
      local_name: params?.localName || undefined,
      selectedFields: params?.selectedFields || {
        custom: false,
        fields: [],
      },
      report_name: params?.report_name || undefined
    },
    config
  );
  return response;
};

const HazardSearchService = {
  customSearch,
};

export default HazardSearchService;
